import {Injectable} from '@angular/core';
import {AuthState} from '../core/auth/store/auth.state';
// Feature States
import * as ShareStore from './share/store';
import * as BookmarkStore from './bookmark/store';
import * as UserStore from './user/store';
import * as FileStore from './file/store';
import * as SettingsStore from './settings/store';
import * as FolderStore from './folder/store';

import {resolveIcon} from '../core/services/utils';

@Injectable()
export class ManagerState {

    ownerId: string;

    constructor(
        private fileState: FileStore.State,
        private authState: AuthState,
        private folderState: FolderStore.State,
        private userState: UserStore.State,
        private bookmarkState: BookmarkStore.State,
        private shareState: ShareStore.State,
        private settingsState: SettingsStore.State) {
        this.authState.profile.subscribe((profile) => this.ownerId = profile.id);

    }

    get rootPath() {
        return '/' + this.ownerId + '/';
    }

    isRoot(path: string): boolean {
        return this.rootPath === path;
    }

    get file() {
        return this.fileState;
    }

    get share() {
        return this.shareState;
    }

    get bookmark() {
        return this.bookmarkState;
    }

    set viewDetails(item) {
        this.folderState.selected = item;
    }

    get viewDetails() {
        return this.folderState.selected;
    }

    get folder() {
        return this.folderState;
    }

    get user() {
        return this.userState;
    }

    get settings() {
        return this.settingsState;
    }

    resolveIcon(contentType) {
        return resolveIcon(contentType);
    }


}
